import { jsx } from 'react/jsx-runtime';
import { useState, useCallback, useEffect } from 'react';
import { OuterBar, InnerBar } from './progress-bar.style.js';

const ProgressBar = (props) => {
    const { automatic = false, className, maxValue = 100, currentValue = 0, complete = false, secondsToProgress = 1, percentageToWaitForComplete = 90, secondsToComplete = 0.2, } = props;
    const [percentage, setPercentage] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const setValues = useCallback((complete = false, percent = percentageToWaitForComplete) => {
        if (complete) {
            setPercentage(100);
            setSeconds(secondsToComplete);
        }
        else {
            setPercentage(percent);
            setSeconds(secondsToProgress);
        }
    }, [percentageToWaitForComplete, secondsToComplete, secondsToProgress]);
    useEffect(() => {
        if (automatic) {
            // We wait for 0 ms so the percentage isn't instantly set to 90 and we can see the transition.
            const delayedPercentageTransition = setTimeout(() => setValues(complete), 0);
            return () => clearTimeout(delayedPercentageTransition);
        }
        else {
            setValues(complete, Math.min((currentValue / maxValue) * 100, percentageToWaitForComplete));
        }
    }, [
        automatic,
        complete,
        currentValue,
        maxValue,
        percentageToWaitForComplete,
        setValues,
    ]);
    return (jsx(OuterBar, Object.assign({ "data-testid": "progress-bar", className: className }, { children: jsx(InnerBar, { "data-testid": "progress-bar-inner-bar", secondsToProgress: seconds, percentage: percentage }, void 0) }), void 0));
};

export { ProgressBar };
